class KuoniChallenge {
    #btnAddChallenge = null;
    #loader = null;

    init = () => {
        document.addEventListener('input', event => {
            const inputChallengerNumber = document.getElementById('challenge-number');

            if(event.target.id === 'challenge-number') {
                if (inputChallengerNumber.value.length !== 7) {
                    inputChallengerNumber.setCustomValidity(wrd.get('challenge_number_must_be_seven_long'));
                } else {
                    inputChallengerNumber.setCustomValidity('');
                }
                inputChallengerNumber.reportValidity();
            }
        });

        document.addEventListener('submit', event => {
            if(event.target.id === 'form-add-challenge') {
                event.preventDefault();
                this.#btnAddChallenge = document.getElementById('btn-add-challenge');
                this.#loader = this.#btnAddChallenge.querySelector('#loader-challenge');

                this.#btnAddChallenge.disabled = true;
                this.#loader.style.display = 'inline-block';

                this.#postAddChallenge();
            }
        });
    }

    #postAddChallenge = () => {
        document.getElementById('alert-add-challenge').classList.add('d-none');
        const form = document.getElementById('form-add-challenge');
        let formData = new FormData(form);

        fetch(`/challenge`, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error();
            }
            return response.json();
        }).then(data => {
            if (data.status === 'OK') {
                form.reset();
                this.#manageDivAlert(wrd.get('challenge_add_succeeded'), 'alert-success');
            } else {
                this.#manageDivAlert(data.message, 'alert-danger');
            }
        })
        .catch(e => {
            this.#manageDivAlert(wrd.get('challenge_add_failed'), 'alert-danger');
            throw e;
        })
        .finally(() => {
            this.#btnAddChallenge.disabled = false;
            this.#loader.style.display = 'none';
        });
    }

    #manageDivAlert(message, backgroundClass) {
        document.getElementById('message-add-challenge').innerText = message;

        const divAlertAddChallenge = document.getElementById('alert-add-challenge');
        divAlertAddChallenge.classList.remove('alert-success', 'alert-danger');
        divAlertAddChallenge.classList.add(backgroundClass);
        divAlertAddChallenge.classList.remove('d-none');
    }
}

document.addEventListener('DOMContentLoaded',
    () => new KuoniChallenge().init()
);
